module.exports = __webpack_public_path__ + "99c6370615da87390270783bc92f1405.png";